import {
    QUANTITY_FORECASTS_LOAD_REQUESTED,
    QUANTITY_FORECASTS_LOAD_SUCCEEDED,
    QUANTITY_FORECASTS_LOAD_FAILED,
    QUANTITY_FORECASTS_SET,
    QUANTITY_FORECAST_CREATE_REQUESTED,
    QUANTITY_FORECAST_CREATE_SUCCEEDED,
    QUANTITY_FORECAST_CREATE_FAILED,
    QUANTITY_FORECAST_UPDATE_REQUESTED,
    QUANTITY_FORECAST_UPDATE_SUCCEEDED,
    QUANTITY_FORECAST_UPDATE_FAILED,
    QUANTITY_FORECASTS_MERGE,
    QUANTITY_FORECAST_SET
} from './constants';

export function requestloadQuantityForecasts(
    seasonId: number,
    entityId: number
) {
    return {
        type: QUANTITY_FORECASTS_LOAD_REQUESTED,
        payload: {
            seasonId,
            entityId
        },
        meta: {
            logentries: true
        }
    };
}

export function succeededLoadQuantityForecasts(response: Record<string, any>) {
    return {
        type: QUANTITY_FORECASTS_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadQuantityForecasts(error: Error) {
    return {
        type: QUANTITY_FORECASTS_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function requestCreateQuantityForecast(data: Record<string, any>) {
    return {
        type: QUANTITY_FORECAST_CREATE_REQUESTED,
        payload: {
            data
        },
        meta: {
            logentries: true
        }
    };
}

export function succeededCreateQuantityForecast(response: Record<string, any>) {
    return {
        type: QUANTITY_FORECAST_CREATE_SUCCEEDED,
        payload: response
    };
}

export function failedCreateQuantityForecast(error: Error) {
    return {
        type: QUANTITY_FORECAST_CREATE_FAILED,
        payload: error,
        error: true
    };
}

export function requestUpdateQuantityForecast(
    quantityForecastId: number,
    data: Record<string, any>
) {
    return {
        type: QUANTITY_FORECAST_UPDATE_REQUESTED,
        payload: {
            quantityForecastId,
            data
        },
        meta: {
            logentries: true
        }
    };
}

export function succeededUpdateQuantityForecast(response: Record<string, any>) {
    return {
        type: QUANTITY_FORECAST_UPDATE_SUCCEEDED,
        payload: response
    };
}

export function failedUpdateQuantityForecast(error: Error) {
    return {
        type: QUANTITY_FORECAST_UPDATE_FAILED,
        payload: error,
        error: true
    };
}

export function setQuantityForecasts(data: Record<string, any>[]) {
    return {
        type: QUANTITY_FORECASTS_SET,
        payload: data,
        meta: {
            keyBy: 'entityId'
        }
    };
}

export function mergeQuantityForecasts(data: Record<string, any>[]) {
    return {
        type: QUANTITY_FORECASTS_MERGE,
        payload: data,
        meta: {
            schemaName: 'quantityForecasts'
        }
    };
}

export function setQuantityForecast(data: Record<string, any>) {
    return {
        type: QUANTITY_FORECAST_SET,
        payload: data,
        meta: {
            schemaName: 'quantityForecast'
        }
    };
}
